import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';

const MobileOnlyBlocker = () => {
  return (
    <Box
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        //padding: 24,
        background: "linear-gradient(135deg, #e3f2fd, #fff)",
        textAlign: "center"
      }}
    >
      <PhoneIphoneIcon style={{ fontSize: 90, color: "#1976d2", marginBottom: 20 }} />

      <Typography variant="h4" style={{ fontWeight: 700, marginBottom: 16 }}>
        Desktop View Only
      </Typography>

      <Typography variant="body1" style={{ maxWidth: 420, color: "#555", marginBottom: 24 }}>
        This app is optimised for desktop devices.  
        Please open it on your desktop for the best experience.
      </Typography>

      {/* <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => window.location.reload()}
        style={{ borderRadius: 30, paddingLeft: 30, paddingRight: 30 }}
      >
        Retry
      </Button> */}
    </Box>
  );
};

export default MobileOnlyBlocker;
